/**
 * Density ramp and glyph atlas for the ASCII pass.
 * The ramp runs dark → bright; index 0 is a space.
 */
export const RAMP =
  " .`'-:_,^=;><+!rc*/z?sLTv)J7(|Fi{C}fI31tlu[neoZ5Yxjya]2ESwqkP6h9d4VpOGbUAKXHm8RD#$Bg0MNWQ%&@"

export interface GlyphAtlas {
  readonly image: ImageBitmap
  readonly count: number
  readonly width: number
  readonly height: number
}

/** Rasterise every ramp glyph into one row, each in a `cellW × cellH` box. */
export function rasterizeGlyphs(cellW: number, cellH: number): GlyphAtlas {
  const count = RAMP.length
  const width = cellW * count
  const height = cellH
  const canvas = new OffscreenCanvas(width, height)
  const ctx = canvas.getContext("2d")
  if (ctx === null) throw new Error("2d context unavailable")

  ctx.fillStyle = "#000"
  ctx.fillRect(0, 0, width, height)
  ctx.fillStyle = "#fff"
  ctx.textAlign = "center"
  ctx.textBaseline = "middle"
  ctx.font = `${Math.round(cellH * 0.82)}px ui-monospace, "SF Mono", Menlo, Consolas, monospace`

  for (let i = 0; i < count; i++) {
    ctx.fillText(RAMP[i] ?? " ", cellW * (i + 0.5), cellH * 0.52)
  }

  return { image: canvas.transferToImageBitmap(), count, width, height }
}
